import { ReactNode } from 'react';

type PanelVariant = 'soft' | 'strong';
type PanelPadding = 'sm' | 'md' | 'lg';

interface GlassPanelProps {
  children: ReactNode;
  className?: string;
  variant?: PanelVariant;
  padding?: PanelPadding;
}

/**
 * Glassmorphism container for cards and panels.
 */
export function GlassPanel({
  children,
  className = '',
  variant = 'soft',
  padding = 'md',
}: GlassPanelProps) {
  const baseClass = variant === 'strong' ? 'glass-strong' : 'glass';
  const paddingClass = getPaddingClass(padding);

  return (
    <div className={`${baseClass} ${paddingClass} rounded-2xl shadow-card ${className}`}>
      {children}
    </div>
  );
}

/**
 * Returns padding classes for the panel.
 */
function getPaddingClass(padding: PanelPadding): string {
  if (padding === 'sm') {
    return 'p-4';
  }

  if (padding === 'lg') {
    return 'p-8';
  }

  return 'p-6';
}
